/**
 * This util triggers form submission from outside the form
 * Bubbles is important so that React Hook form can bind the form submission properly
 */

const submitFormFromOutside = (formElement: HTMLFormElement) => {
  formElement.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
}

export default submitFormFromOutside
